// src/pages/NotFound.js
// 404 page — shown for any route that doesn't match the router.
// Gives the user clear options to get back on track.

import React from 'react';
import { Link } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';

const NotFound = () => {
    usePageTitle('Page Not Found', 'The page you\'re looking for doesn\'t exist. Head back to MAISON D\'OUD.');

    return (
        <div className="bg-background min-h-screen flex items-center justify-center px-6 transition-colors duration-300">
            <div className="text-center">
                <p className="text-[#CEAC8F] text-sm tracking-widest uppercase mb-4">404</p>
                <h1 className="text-5xl md:text-6xl font-light text-foreground mb-6 tracking-wide">
                    Page Not Found
                </h1>
                <p className="text-muted-foreground text-lg max-w-md mx-auto mb-10 leading-relaxed">
                    The page you're looking for doesn't exist or has been moved. Let's get you back on track.
                </p>

                {/* Navigation options */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                        to="/"
                        className="bg-[#CEAC8F] text-black px-8 py-4 rounded-lg font-medium hover:bg-[#d4b896] transition-colors"
                    >
                        Back to Home
                    </Link>
                    <Link
                        to="/scents"
                        className="border border-[#CEAC8F]/30 text-[#CEAC8F] px-8 py-4 rounded-lg font-medium hover:border-[#CEAC8F] transition-colors"
                    >
                        Our Scents
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotFound;